const mes = (d) => d.toLocaleDateString("es-ES", { month: "short", year: "numeric" }).replace(".", "").replace(" de ", " ");

/** "nov 2025 – oct 2026": periodo de ventas que cubre un estudio de stock. */
export function periodoVentas(study) {
  if (!study) return "";
  const finStr = String(study.period_to || study.created_at || "").slice(0, 10);
  if (finStr.length < 10) return "";
  const fin = new Date(`${finStr}T12:00:00`);
  const dias = Number(study.period_days) || 0;
  const ini = study.period_from && !dias ? new Date(`${String(study.period_from).slice(0, 10)}T12:00:00`)
    : new Date(fin.getTime() - Math.max(dias - 1, 0) * 86400000);
  const a = mes(ini), b = mes(fin);
  return a === b ? a : `${a} – ${b}`;
}

export const ventasLabel = (periodo) => (periodo ? `Ventas (${periodo}, a PVP)` : "Ventas (a PVP)");
